import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Dashboard from '../views/Dashboard.vue'
import EmailConfigs from '../views/EmailConfigs.vue'
import Recipients from '../views/Recipients.vue'
import SendEmail from '../views/SendEmail.vue'
import SendLogs from '../views/SendLogs.vue'
import SetPassword from '../views/SetPassword.vue'
import EnterpriseScreening from '../views/products/EnterpriseScreening.vue'
import GlobalAcquisition from '../views/products/GlobalAcquisition.vue'
import Promotion from '../views/products/Promotion.vue'
import AdvancedMailer from '../views/products/AdvancedMailer.vue'
import UsageGuide from '../views/UsageGuide.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Landing',
		component: () => import('../views/Landing.vue'),
		meta: { requiresGuest: true }
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: { requiresGuest: true }
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta: { requiresGuest: true }
	},
	{
		path: '/set-password',
		name: 'SetPassword',
		component: SetPassword,
		meta: { requiresAuth: true }
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		meta: { requiresAuth: true }
	},
	{
		path: '/usage-guide',
		name: 'UsageGuide',
		component: UsageGuide,
		meta: { requiresAuth: true }
	},
	{
		path: '/email-configs',
		name: 'EmailConfigs',
		component: EmailConfigs,
		meta: { requiresAuth: true }
	},
	{
		path: '/recipients',
		name: 'Recipients',
		component: Recipients,
		meta: { requiresAuth: true }
	},
	{
		path: '/send-email',
		name: 'SendEmail',
		component: SendEmail,
		meta: { requiresAuth: true }
	},
	{
		path: '/send-logs',
		name: 'SendLogs',
		component: SendLogs,
		meta: { requiresAuth: true }
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import('../views/Contact.vue'),
		meta: { requiresAuth: true }
	},
	// 产品介绍
	{
		path: '/products/enterprise-screening',
		name: 'EnterpriseScreening',
		component: EnterpriseScreening,
		meta: { requiresAuth: true }
	},
	{
		path: '/products/global-acquisition',
		name: 'GlobalAcquisition',
		component: GlobalAcquisition,
		meta: { requiresAuth: true }
	},
	{
		path: '/products/promotion',
		name: 'Promotion',
		component: Promotion,
		meta: { requiresAuth: true }
	},
	{
		path: '/products/advanced-mailer',
		name: 'AdvancedMailer',
		component: AdvancedMailer,
		meta: { requiresAuth: true }
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
	const isLoggedIn = store.getters.isLoggedIn;
	
	if (to.meta.requiresAuth && !isLoggedIn) {
		// 需要认证但未登录，跳转到登录页
		next('/login');
	} else if (to.meta.requiresGuest && isLoggedIn) {
		// 需要游客状态但已登录，跳转到仪表板
		next('/dashboard');
	} else {
		next();
	}
});

export default router 